import { resourceManagementAPIConfig } from "../authConfig";
import { SensitivityLabel } from "../enums";
import { activityLog } from "../objects/activityLog";
import { archivedSite } from "../objects/archivedSite";
import { department } from "../objects/department";
import { directoryObject } from "../objects/directoryObj";
import { M365GroupActivity } from "../objects/m365GroupActivity";
import { m365group } from "../objects/m365group";
import { permissionReportRequest } from "../objects/permissionReportRequest";
import { sensitivityLabelChange } from "../objects/sensitivityLabelChange";
import { spoSiteOwnershipChange } from "../objects/spoOwnershipChange";
import { nonConnectedSite } from "../objects/spoSite";
import { SharePointActivity } from "../objects/spoSiteActivity";
import { team } from "../objects/team";
import { UserFeedback } from "../objects/userFeedback";



export async function getCurrentUserActivity(accessToken: string): Promise<Array<activityLog>> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "GET",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}/activity${resourceManagementAPIConfig.getMyActivity}`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}

export async function getOwnedM365Groups(accessToken: string): Promise<Array<m365group>> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "GET",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}${resourceManagementAPIConfig.getM365Spaces}`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}


export async function getOwnedStandaloneSPOSites(accessToken: string): Promise<Array<nonConnectedSite>> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "GET",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}${resourceManagementAPIConfig.getSPOSpaces}`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}

export async function getOwnedArchivedResources(accessToken: string): Promise<Array<archivedSite>> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "GET",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}/resources/archived/getowned`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}

export async function getSingleOwnedM365Group(accessToken: string, groupObjectId: string): Promise<m365group> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "GET",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}${resourceManagementAPIConfig.getSPOSpaces}/${groupObjectId}`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}

export async function getSingleOwnedTeam(accessToken: string, groupObjectId: string): Promise<team> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "GET",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}${resourceManagementAPIConfig.getM365Spaces}/${groupObjectId}/team`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}

export async function getM365GroupGuests(accessToken: string, groupObjectId: string): Promise<Array<directoryObject>> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "GET",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}${resourceManagementAPIConfig.getM365Spaces}/${groupObjectId}/guests`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}

export async function getSPOSiteGuests(accessToken: string, siteId: string): Promise<Array<directoryObject>> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "GET",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}${resourceManagementAPIConfig.getSPOSpaces}/${siteId}/guests`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}

export async function getM365GroupOwners(accessToken: string, groupObjectId: string): Promise<Array<directoryObject>> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "GET",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}${resourceManagementAPIConfig.getM365Spaces}/${groupObjectId}/owners`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}

export async function getSPOSiteOwners(accessToken: string, siteUrl: string): Promise<Array<directoryObject>> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "GET",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}${resourceManagementAPIConfig.getSPOSpaces}/${siteUrl}/owners`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}

export async function getM365GroupActivity(accessToken: string, groupObjectId: string): Promise<M365GroupActivity> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "GET",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}${resourceManagementAPIConfig.getM365Spaces}/${groupObjectId}/activity`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}

export async function getSPOSiteActivity(accessToken: string, siteUrl: string): Promise<SharePointActivity> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "GET",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}${resourceManagementAPIConfig.getSPOSpaces}/${siteUrl}/activity`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}

export async function addSPOSiteOwner(accessToken: string, siteUrl: string, email: string): Promise<number> {
    let ownershipObj = new spoSiteOwnershipChange();
    ownershipObj.siteUrl = siteUrl;
    ownershipObj.newOwnerEmail = email;
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "PUT",
        headers: headers,
        mode : "cors",
        body: JSON.stringify(ownershipObj)
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}${resourceManagementAPIConfig.getSPOSpaces}/addowner`, options)
        .then(response => response.status)
        .catch(error => {throw error;});
}

export async function removeSPOSiteOwner(accessToken: string, siteUrl: string, email: string): Promise<number> {
    let ownershipObj = new spoSiteOwnershipChange();
    ownershipObj.siteUrl = siteUrl;
    ownershipObj.newOwnerEmail = email;
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "POST",
        headers: headers,
        mode : "cors",
        body: JSON.stringify(ownershipObj)
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}${resourceManagementAPIConfig.getSPOSpaces}/removeowner`, options)
        .then(response => response.status)
        .catch(error => {throw error;});
}

export async function addM365GroupOwner(accessToken: string, groupId: string, userId: string): Promise<number> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "PUT",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}${resourceManagementAPIConfig.getM365Spaces}/${groupId}/owners/${userId}`, options)
        .then(response => response.status)
        .catch(error => {throw error;});
}

export async function removeM365GroupOwner(accessToken: string, groupId: string, userId: string): Promise<number> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "DELETE",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}${resourceManagementAPIConfig.getM365Spaces}/${groupId}/owners/${userId}`, options)
        .then(response => response.status)
        .catch(error => {throw error;});
}

export async function extendResourceLease(accessToken: string, resourceIdentifier: string, isM365Connected: boolean): Promise<number> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "POST",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}/resources/extendlease?resourceIdentifier=${resourceIdentifier}&isM365Connected=${isM365Connected}`, options)
        .then(response => response.status)
        .catch(error => {throw error;});
}

export async function removeGuestFromWorkspace(accessToken: string, resourceIdentifier: string, isM365Connected: boolean,guestIdentifier: string): Promise<number> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "POST",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}/resources/removeguest?resourceIdentifier=${resourceIdentifier}&isM365Connected=${isM365Connected}&guestIdentifier=${guestIdentifier}`, options)
        .then(response => response.status)
        .catch(error => {throw error;});
}

export async function updateSensitivityLabel(accessToken: string, resourceIdentifier: string, isM365Connected: boolean,newSensitivityLabel:SensitivityLabel): Promise<number> {
    let newChangeObj = new sensitivityLabelChange();
    newChangeObj.resourceIdentifier = resourceIdentifier;
    newChangeObj.isM365Connected =  isM365Connected;
    newChangeObj.newSensitivityLabel = newSensitivityLabel as string;
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "POST",
        headers: headers,
        mode : "cors",
        body: JSON.stringify(newChangeObj)
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}/resources/updatesensitivitylabel`, options)
        .then(response => response.status)
        .catch(error => {throw error;});
}

export async function deletem365Group(accessToken: string, groupId: string): Promise<number> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "DELETE",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}${resourceManagementAPIConfig.getM365Spaces}/${groupId}`, options)
        .then(response => response.status)
        .catch(error => {throw error;});
}

export async function deleteSPOSite(accessToken: string, siteUrl: string): Promise<number> {

    let spoSiteObj = { siteUrl , Id : ""}
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "POST",
        headers: headers,
        mode : "cors",
        body: JSON.stringify(spoSiteObj)
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}${resourceManagementAPIConfig.getSPOSpaces}/delete`, options)
        .then(response => response.status)
        .catch(error => {throw error;});
}

export async function addUserFeedBackEntry(accessToken: string, userFeedbackScore: number,userFeedbackComments: string): Promise<number> {

    let userFeedbackObj = new UserFeedback();
    userFeedbackObj.feedbackScore = userFeedbackScore;
    userFeedbackObj.feedbackComments = userFeedbackComments;
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "POST",
        headers: headers,
        mode : "cors",
        body: JSON.stringify(userFeedbackObj)
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}/resources/feedback`, options)
        .then(response => response.status)
        .catch(error => {throw error;});
}

export async function requestPermissionReport(accessToken: string, isM365Connected: boolean, resourceIdentifier: string): Promise<number> {

    let reportRequest = new permissionReportRequest();
    reportRequest.isM365Connected = isM365Connected;
    reportRequest.resourceIdentifier = resourceIdentifier;
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "POST",
        headers: headers,
        mode : "cors",
        body: JSON.stringify(reportRequest)
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}/reports/spopermissions`, options)
        .then(response => response.status)
        .catch(error => {throw error;});
}

export async function addArchivedSiteOwner(accessToken: string, resourceId: string, userId: string): Promise<number> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "PUT",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}/resources/archived/addowner?resourceId=${resourceId}&newOwnerId=${userId}`, options)
        .then(response => response.status)
        .catch(error => {throw error;});
}

export async function removeArchivedSiteOwner(accessToken: string, resourceId: string, userId: string): Promise<number> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "DELETE",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}/resources/archived/removeowner?resourceId=${resourceId}&ownerToRemoveId=${userId}`, options)
        .then(response => response.status)
        .catch(error => {throw error;});
}

export async function reactivateResource(accessToken: string, resourceId: string): Promise<number> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "POST",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}/resources/archived/dearchive?resourceId=${resourceId}`, options)
        .then(response => response.status)
        .catch(error => {throw error;});
}


export async function requestArchiveSite(accessToken: string, archivedSite: archivedSite): Promise<number> {
  const headers = new Headers({});
  headers.set("Content-Type", "application/json");
  headers.append("Authorization", `Bearer ${accessToken}`);

  const options: RequestInit = {
    method: "POST",
    headers: headers,
    mode: "cors",
    body: JSON.stringify(archivedSite),
  };

  return fetch(`${resourceManagementAPIConfig.baseURL}/resources/archived/archive`, options)
    .then(response => response.status)
    .catch(error => {
      console.error("Error archiving site:", error);
      throw error;
    });
}


export async function getDepartment(accessToken: string, departmentCode: string): Promise<Array<department>> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "GET",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}/resources/departments/${departmentCode}`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}

export async function getDepartmentChildren(accessToken: string, departmentCode: string): Promise<Array<department>> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "GET",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}/resources/departments/${departmentCode}/children`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}

export async function getDepartmentByLevel(accessToken: string, departmentLevel: number): Promise<Array<department>> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "GET",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}/resources/departments/byLevel/${departmentLevel}`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}

export async function updateWorkspaceDepartment(accessToken: string, resourceId:string,departmentCd:string,isConnected:boolean): Promise<department> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "POST",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}/resources/departments/?resourceId=${resourceId}&departmentCd=${departmentCd}&isConnected=${isConnected}`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}
export async function getSingleOwnedResource(accessToken: string, resourceid:string,isconnected:boolean): Promise<Array<any>> {
    const headers = new Headers({});
    headers.set('Content-Type', 'application/json');
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options : RequestInit= {
        method: "GET",
        headers: headers,
        mode : "cors"
    };

    return fetch(`${resourceManagementAPIConfig.baseURL}/resources/owned?resourceIdentifier=${resourceid}&isM365Connected=${isconnected}`, options)
        .then(response => response.json())
        .catch(error => {throw error;});
}